import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { CONTACT_WIZARD_SAMPLE } from "../consts";
import { getContactName } from "../helpers";
import { ContactWizardSceneProps } from "../types";

/** Korak "Adrese": adrese s primarnom i oznaka primarne adrese na karti. */
const AddressScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const name = getContactName(formValues);
  const [primaryAddress] = CONTACT_WIZARD_SAMPLE.addresses;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Adrese</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {CONTACT_WIZARD_SAMPLE.addresses.map((address) => (
              <div key={address.line1} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-[0.6rem] font-semibold uppercase tracking-wide text-slate-400">{address.description}</span>
                  {address.primary && (
                    <span className="px-1.5 py-0.5 rounded-full bg-emerald-100 text-[0.55rem] font-semibold text-emerald-700 flex-shrink-0">
                      Primarna
                    </span>
                  )}
                </div>
                <div className="mt-0.5 font-semibold text-slate-800 truncate">{address.line1}</div>
                <div className="text-[0.6rem] text-slate-500 truncate">{address.city}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-3">
          {/* Stilizirana karta: mreža ulica i oznaka primarne adrese. */}
          <div className="relative h-24 rounded-md bg-emerald-50 overflow-hidden">
            <span className="absolute left-0 right-0 top-8 h-1.5 bg-white" />
            <span className="absolute left-0 right-0 top-16 h-1 bg-white" />
            <span className="absolute top-0 bottom-0 left-10 w-1.5 bg-white" />
            <span className="absolute top-0 bottom-0 right-12 w-1 bg-white" />
            <svg className="absolute left-1/2 top-1/2 w-7 h-7 -translate-x-1/2 -translate-y-full" viewBox="0 0 24 24" fill="#2563EB" stroke="#FFFFFF" strokeWidth="1.5" aria-hidden="true">
              <path d="M12 22s7-7.75 7-13a7 7 0 00-14 0c0 5.25 7 13 7 13z" />
              <circle cx="12" cy="9" r="2.5" fill="#FFFFFF" />
            </svg>
          </div>
          <div className="mt-2 px-2 text-[0.65rem] font-semibold text-slate-700 truncate">{primaryAddress.line1}</div>
          <div className="px-2 text-[0.6rem] text-slate-400 truncate">{primaryAddress.city}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Primarna adresa ide prva"
          subtitle="Sjedište, poslovnica ili dostava"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 21s7-7.75 7-13a7 7 0 00-14 0c0 5.25 7 13 7 13z" />
              <circle cx="12" cy="8" r="2.5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(AddressScene);
